import { colorMap as discColorMap } from '@aibees/elephant/components/disc-profile/config';
import { colorMap as big5ColorMap } from '@aibees/elephant/components/personality-analysis-big5-profile/config';
import { usePersonReadDataContext } from '@aibees/elephant/context';

export const useProfileLabelConfigs = () => {
  const { api } = usePersonReadDataContext();

  const discLabels =
    api?.data?.revelation?.analysis?.content?.assessments?.disc?.summary
      .labels || [];

  const big5Labels =
    api?.data?.revelation?.analysis?.content?.assessments?.ocean?.summary
      .labels || [];

  return [
    { title: 'Disc', labels: discLabels, colorMap: discColorMap },
    { title: 'Big 5', labels: big5Labels, colorMap: big5ColorMap },
  ];
};
